import { render } from "./selectMarca.vue?vue&type=template&id=53389ea9"
import script from "./selectMarca.vue?vue&type=script&lang=ts"
export * from "./selectMarca.vue?vue&type=script&lang=ts"
script.render = render

export default script